import _Watermark from './watermark';
import withInstall from '../utils/withInstall';

export * from './type';

export const Watermark = withInstall(_Watermark);
export default Watermark;
